import React, { Component, Fragment } from 'react';
import { FieldGroup, FieldControl, FormBuilder, Validators } from 'react-reactive-form';
import { Link } from 'react-router-dom';
import { Auth, API } from 'aws-amplify';
import { readableResponseMessage, passwordValidator } from 'ux-helpers';
import PropTypes from 'proptypes';

import '../../lib/forms/Forms.scss';

export default class SignIn extends Component {
  state = {
    message: '',
    successfullyVerifiedAccount: this.props.userProps.successfullyVerifiedAccount
      ? this.props.userProps.successfullyVerifiedAccount
      : false,
  };

  componentDidMount() {
    window.scrollTo({
      top: 400,
      behavior: 'smooth',
    });
  }

  handleSubmit = (e, formVals) => {
    e.preventDefault();
    if (this.props.autoLogin === true) {
      this.signInForm.controls['password'].setValue(this.props.userProps.password);
      this.signIn(this.props.userProps);
    } else {
      this.signIn(formVals);
    }
  };

  signIn = async formVals => {
    if (this.signInForm.status === 'VALID') {
      this.setState({ loadingBtn: true });
      this.signInForm.handleSubmit();
      Auth.signIn(formVals.emailAddress, formVals.password)
        .then(AuthenicatedUser => {
          const authenticatedUserData = AuthenicatedUser.signInUserSession.idToken.payload;
          const userProps = {
            emailAddress: authenticatedUserData.email,
            phoneNumber: `${
              authenticatedUserData.phone_number
                ? authenticatedUserData.phone_number.replace(/[^\d]/g, '')
                : ''
            }`,
            mobilePhoneNumber: `${
              authenticatedUserData.phone_number
                ? authenticatedUserData.phone_number.replace(/[^\d]/g, '')
                : ''
            }`,
            firstName: authenticatedUserData.given_name ? authenticatedUserData.given_name : '',
            lastName: authenticatedUserData.given_name ? authenticatedUserData.family_name : '',
          };
          this.props.setParentState('userProps', userProps);
          const { username } = AuthenicatedUser;
          this.props.onLogin(username);
          // Send login event to API
          const authOptions = {
            headers: {
              Authorization: AuthenicatedUser.signInUserSession.idToken.jwtToken,
              Token: AuthenicatedUser.signInUserSession.accessToken.jwtToken,
              'Content-Type': 'application/json',
            },
            body: {
              email: formVals.emailAddress,
            },
          };
          API.post('give-api', '/user/actions', authOptions)
            .then(response => {
              // console.log(response);
            })
            .catch(error => {
              console.error(error);
            });
          this.props.handleRouting();
        })
        .catch(error => {
          if (error.message === 'User is not confirmed.') {
            this.props.setParentState('userProps', {
              emailAddress: formVals.emailAddress,
            });
            this.props.history.push('/verify-account');
          } else {
            this.setState({
              loadingBtn: false,
              message:
                error.code === 'UserNotFoundException'
                  ? 'Please make sure your email and password are correct.'
                  : readableResponseMessage(error),
            });
            this.signInForm.handleSubmit();
          }
        });
    } else {
      let errorMessage =
        'Please make sure your email and password are correct. If you have not created an account on the new volunteer profile, please click on the link above.';
      const passwordObject = this.signInForm.get('password');
      if (passwordObject.status === 'INVALID' && passwordObject.value.length <= 4) {
        errorMessage =
          "If you trying to login with the credentials from the previous volunteer profile, please create a new account using the link above. Also, please make sure you create an account using the same email address you had used with the previous volunteer profile, and we'll link your accounts!";
      }
      this.setState({
        loadingBtn: false,
        message: errorMessage,
      });
      this.signInForm.handleSubmit();
    }
  };

  signInForm = FormBuilder.group({
    emailAddress: [this.props.userProps.emailAddress, [Validators.required, Validators.email]],
    password: ['', [Validators.required, passwordValidator]],
  });

  render() {
    return (
      <div className="row center justify-content-center">
        <div className="col-md-6 col-sm-12">
          <h2>Log In</h2>
          {this.state.successfullyVerifiedAccount ? (
            <div>
              <p className="success">
                Successfully verified account. &#x2714;
                <br />
                Please sign-in with your email address and new password.
              </p>
            </div>
          ) : (
            <p>
              Welcome to the GIVE Profile! If this is your first time logging in, please{' '}
              <Link to="/sign-up">create a new account here</Link>.
            </p>
          )}
          {this.state.message ? <p className="error">{this.state.message}</p> : ''}
          <div>
            <Fragment>
              <FieldGroup
                control={this.signInForm}
                render={({ submitted, value }) => (
                  <form
                    name="Sign-In"
                    id="login-form"
                    onSubmit={e => this.handleSubmit(e, value)}
                    autoComplete="off"
                  >
                    <FieldControl
                      name="emailAddress"
                      render={({ handler, touched, hasError, pristine, onBlur }) => (
                        <div className="inputContainer">
                          <input
                            name="email"
                            id="emailAddress"
                            className="signin-input form-control"
                            type="email"
                            readOnly={this.props.autoLogin}
                            {...handler()}
                          />
                          <label
                            htmlFor="emailAddress"
                            className={`label ${
                              pristine && !this.props.userProps.emailAddress ? '' : 'notEmpty'
                            }`}
                          >
                            Email
                            <span className="error">
                              {(touched || submitted) && hasError('required') && ' - Required'}
                              {onBlur && touched && hasError('email') && ' - Not a Valid Email'}
                            </span>
                          </label>
                        </div>
                      )}
                    />
                    <FieldControl
                      name="password"
                      render={({ handler, touched, pristine, hasError }) => (
                        <div className="inputContainer">
                          <input
                            name="password"
                            id="password"
                            className="signin-input form-control"
                            type="password"
                            readOnly={this.props.autoLogin}
                            {...handler()}
                          />
                          <label
                            id="pw-label"
                            htmlFor="password"
                            className={`label ${pristine ? '' : 'notEmpty'}`}
                          >
                            Password
                            <span className="error">
                              {(touched || submitted) && hasError('required') && ' - Required'}
                            </span>
                          </label>
                        </div>
                      )}
                    />

                    <button
                      id="login-button"
                      className={`margin-center ${this.state.loadingBtn ? 'btn-text-hide' : ''}`}
                      type="submit"
                      disabled={this.state.loadingBtn}
                    >
                      Log In
                      <span className={`${this.state.loadingBtn ? 'loader' : ''}`} />
                    </button>

                    <p className="signin-text">
                      <Link to="/sign-up"> Create Your New Account!</Link>
                    </p>
                    <p className="signin-text">
                      <Link to="/forgot-password">Forgot Password?</Link>
                    </p>
                  </form>
                )}
              />
            </Fragment>
          </div>
        </div>
      </div>
    );
  }
}

SignIn.propTypes = {
  onLogin: PropTypes.func.isRequired,
  handleRouting: PropTypes.func.isRequired,
  setParentState: PropTypes.func.isRequired,
  userProps: PropTypes.shape({
    emailAddress: PropTypes.string,
    successfullyVerifiedAccount: PropTypes.bool,
  }),
  autoLogin: PropTypes.bool,
};

SignIn.defaultProps = {
  successfullyVerifiedAccount: () => false,
  userProps: {},
  autoLogin: false,
};
